import React from "react";
import { Grid, TextField, MenuItem } from "@mui/material";
import { CustomSignalSchottky } from "../../models/signalSources/customSignal.ts";
import { Signal } from "../../models/signal.ts";
import { getSignalLabelFromList } from "../../utils/signalUtils.ts";

interface Props {
  data: CustomSignalSchottky;
  onChange: (value: CustomSignalSchottky) => void;
  setIsValid: (valid: boolean) => void;
  signalOptions: Signal[];
}

const EditSchottkySignalForm: React.FC<Props> = ({ data, onChange, setIsValid, signalOptions }) => {
  const handleChange = (updated: CustomSignalSchottky) => {
    onChange(updated);
    updated.name = "Schottky";
    setIsValid(updated.source_signal.id !== "" && updated.net !== "");
  };

  return (
    <Grid container spacing={2} sx={{ mt: 2 }}>
      <Grid size={12}>
        <TextField
          select fullWidth label="Quellsignal"
          value={data.source_signal.id}
          error={data.source_signal.id === ""}
          onChange={(e) => {
            const selected = signalOptions.find(s => s.id === e.target.value);
            if (selected) handleChange({ ...data, source_signal: selected });
          }}
        >
          {signalOptions.map(opt => (
            <MenuItem key={opt.id} value={opt.id}>
              {getSignalLabelFromList(opt.id, signalOptions)}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={12}>
        <TextField
          fullWidth
          required
          label="Signal Name"
          value={data.net}
          error={data.net === ""}
          onChange={(e) => handleChange({ ...data, net: e.target.value })}
        />
      </Grid>
      <Grid size={12}>
        <TextField
          select
          fullWidth
          label="Max. Strom"
          value={data.current}
          onChange={(e) => handleChange({ ...data, current: e.target.value as CustomSignalSchottky["current"] })}
        >
          <MenuItem value="0,1A">0,1 A</MenuItem>
          <MenuItem value="1A">1 A</MenuItem>
          <MenuItem value="3A">3 A</MenuItem>
        </TextField>
      </Grid>
    </Grid>
  );
};

export default EditSchottkySignalForm;
